import { createApp } from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'
import { axiosHandler } from '@/handler/axiosHandler';
import Notifications from '@kyvg/vue3-notification'
import crypto from '@/helpers/crypto';
import notifyPlugin from '@/helpers/notify'
import customNotification from "@/components/Main/CustomNotification.vue";

const app = createApp(App)
app.config.globalProperties.$user = localStorage.getItem('user') ? JSON.parse(crypto.decrypt(localStorage.getItem('user'))) : ''
app.use(store)
app.use(router)
app.use(VueTheMask)
app.use(axiosHandler)
app.use(notifyPlugin)
app.use(Notifications)
app.mount('#kt_body')
